var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C2.69152 0 0 2.69152 0 6C0 9.30848 2.69152 12 6 12C9.30848 12 12 9.30848 12 6C12 2.69152 9.30848 0 6 0ZM6 11.0769C3.20063 11.0769 0.923077 8.7994 0.923077 6C0.923077 3.2006 3.2006 0.923077 6 0.923077C8.7994 0.923077 11.0769 3.2006 11.0769 6C11.0769 8.7994 8.7994 11.0769 6 11.0769ZM9.23077 5.53846H6.46154L6.46163 1.89019C6.46163 1.63531 6.25504 1.4286 6.00004 1.4286C5.74516 1.4286 5.53846 1.6352 5.53846 1.89019V6C5.53846 6.25488 5.74505 6.46159 6.00004 6.46159H9.23081C9.4857 6.46159 9.6924 6.25499 9.6924 6C9.6924 5.74512 9.48567 5.53846 9.23077 5.53846Z",
    fill: "#6F7E8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clockIcon.3f15759cba5b90d1a020857f228cf682.svg";
export { ForwardRef as ReactComponent };